module.exports = __webpack_public_path__ + "static/media/400x300x200-125F11.1ba5da3c.jfif";


//////////////////
// WEBPACK FOOTER
// ./src/images/sales/400x300x200-125F11.jfif
// module id = 234
// module chunks = 0